<template>
  <div
    v-if="options"
    class="dropdown open"
    :class="{ selected }"
  >
    <div class="dropdown-box">
      <!-- TODO: replace svg with icon component -->
      <img v-if="useInputLeftIcons" src="../assets/icons/trade.svg" alt="building icon">
      <!-- Dropdown Input -->
      <input
        id="search-dropdown"
        v-on-clickaway="handleBlur"
        :value="searchFilter"
        class="dropdown-input"
        :class="{ 'dropdown-input--no-left-icon': !useInputLeftIcons }"
        name="tradelist"
        data-hj-whitelist
        :disabled="disabled"
        autocomplete="off"
        :placeholder="computedPlaceholder"
        @input="filterVal = $event.target.value"
        @keydown="keyMonitor"
      >
    </div>
    <!-- Dropdown Menu -->
    <div v-show="filterVal" class="dropdown-content">
      <div
        v-for="option in filteredOptions"
        :key="option.trade"
        :class="{'fallback-option': option.fallback}"
        class="dropdown-item"
        @mousedown="selectOption(option)"
      >
        {{ option.trade }}
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { mapGetters } from 'vuex'

import tradeOptions from '../assets/data/trades.json'

export default {
  name: 'TradeList',
  mixins: [ clickaway ],
  props: {
    value: {
      type: Object,
      required: true
    },
    useInputLeftIcons: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      options: tradeOptions,
      filterVal: '',
      disabled: false
    }
  },

  computed: {
    ...mapGetters([ 'isMobile' ]),

    computedPlaceholder () {
      return this.isMobile ? 'Enter your business type...' : 'Enter in your business type...'
    },
    searchFilter: {
      get () {
        if (this.filterVal) {
          return this.filterVal
        }

        if (this.value && this.value.result) {
          return this.value.result
        } else {
          return ''
        }
      },
      set () {}
    },
    selected () {
      return this.options.find(option => option.trade === this.value.result)
    },
    filteredOptions () {
      let filtered = this.options.filter(option => {
        return option.trade.toLowerCase().includes(this.filterVal.toLowerCase())
      })

      if (filtered.length < 1) {
        return [{
          trade: 'My trade is not listed',
          fallback: true
        }]
      }

      const sorted = filtered.reduce((result, option) => {
        const optionFirstLetter = option.trade.toLowerCase().charAt(0)
        const queryFirstLetter = this.filterVal.toLowerCase().charAt(0)
        if (optionFirstLetter === queryFirstLetter) {
          result.prefix.push(option)
        } else {
          result.other.push(option)
        }
        return result
      }, { prefix: [], other: [] })

      return [...sorted.prefix, ...sorted.other]
    }
  },

  methods: {
    selectOption (option) {
      this.filterVal = ''
      this.input(option.trade)
    },
    handleBlur () {
      this.filterVal = ''
    },
    keyMonitor: function (event) {
      this.filterVal = event.currentTarget.value

      if (event.key === 'Backspace') {
        this.input()
        if (this.filterVal.length === 1) this.filterVal = ''
      }
      if (event.key === 'Enter' && this.filteredOptions[0]) {
        this.selectOption(this.filteredOptions[0])
      }
    },
    input (result) {
      this.$emit('input', { result })
    }
  },

  template: 'Dropdown'
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: block;
  box-shadow: $shadow-light;

  &.open {
    .dropdown-content {
      box-shadow: $shadow-light;
    }

    .dropdown-input {
      background-color: $white;
    }
  }

  .dropdown-arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .dropdown-box {
    display: flex;
    align-items: center;
    height: 80px;
    padding: $spacing-0 $spacing-24;
    background-color: $white;
    border-radius: $border-radius-medium;

    @media (max-width: $screen-md) {
      flex-direction: row-reverse;
      height: 56px;
      padding: $spacing-0 $spacing-20;
    }
  }

  .dropdown-input {
    border: 0;
    color: $tradelist-text;
    font-size: 18px;
    font-weight: 500;
    padding: $spacing-0 $spacing-20;
    font-weight: bold;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    outline: none;

    &--no-left-icon {
      padding: $spacing-0;
    }

    @media (max-width: $screen-md) {
      padding: 0 $spacing-8 0 0;
    }

    &::placeholder {
      font-weight: normal;
      color: $black;
      opacity: 0.3;
    }

    &:focus {
      background-color: $white;
    }
  }
  .dropdown-content {
    position: absolute;
    background-color: #fff;
    max-width: none;
    border: 1px solid #e7ecf5;
    overflow: auto;
    width: 100%;
    border-radius: $border-radius-medium;
    transform: translateY(-5px);
    max-height: 300px;
    z-index: 1;

    @media (max-height: 670px) and (min-width: $screen-md) {
      max-height: 200px;
    }

    .dropdown-item {
      color: $tradelist-text;
      font-size: 17px;
      line-height: 1em;
      padding: $spacing-16 $spacing-24;
      text-decoration: none;
      display: block;
      width: 100%;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      cursor: pointer;
      &:hover {
        background-color: #e7ecf5;
      }

      &.fallback-option {
        font-weight: bold;
      }
    }
  }
  .dropdown:hover .dropdowncontent {
    display: block;
  }
}
</style>
